import React from "react";
import Context from "../../../../../Context";
import WorkflowProfile from "./WorkflowProfile";
import { Modal } from "react-bootstrap";
import WorkflowAdd from "./WorkflowAdd";
import WorkflowTypes from "./WorkflowTypes";
import WorkflowConstructor from "./WorkflowConstructor";
import WorkflowSecurity from "./WorkflowSecurity";

export default class WorkflowDetail extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      add: false,
      mode: "workflow",
    };
  }

  deleteClick = () => {
    if (!this.props.activeItem) return false;
    this.context
      .ask(
        `Вы действительно хотите удалить класс документооборота`,
        "Удаление класса",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete();
        }
      });
  };

  delete = async () => {
    this.setState({ pending: true });

    let result = await this.context.api.q("/workflow/class/delete", {
      id: this.props.activeItem,
    });
    if (result !== false) {
      this.context.toast(`Класс удален`, "success");
      this.props.onFinish();
    } else {
      this.context.toast(`Не удалось удалить класс`, "error");
    }

    this.setState({ pending: false, mode: "workflow" });
  };

  renderNav() {
    let nav = {
      workflow: "Документооборот",
      edit: "Правка",
      types: "Типы",
      security: "Безопасность",
    };
    return (
      <ul className="nav nav-tabs mb-10">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <span
              onClick={() => this.setState({ mode: id })}
              className={` ${
                this.state.mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </span>
          </li>
        ))}
      </ul>
    );
  }

  renderButtons() {
    return (
      <>
        <button
          title="Создать класс документооборота"
          onClick={() => this.setState({ add: true })}
          className={`btn ${
            this.state.add ? "btn-light-primary" : "btn-light"
          } p-2  mr-2`}
        >
          <span className="flaticon2-add-1 px-2 align-middle"></span>
        </button>
        {this.props.activeItem ? (
          <button
            title="Удалить класс документооборота"
            onClick={this.deleteClick}
            className={"btn btn-light p-2 text-hover-danger"}
          >
            <span className="flaticon2-rubbish-bin px-2 align-middle"></span>
          </button>
        ) : null}
      </>
    );
  }

  componentDidMount() {
    this.context.actionsSet(this.renderButtons());
  }

  render() {
    if (!this.props.activeItem) return null;

    return (
      <>
        {this.renderNav()}
        {this.state.mode === "edit" ? (
          <WorkflowProfile
            activeItem={this.props.activeItem}
            onFinish={this.props.onFinish}
          />
        ) : null}
        {this.state.mode === "types" ? (
          <WorkflowTypes activeItem={this.props.activeItem} />
        ) : null}
        {this.state.mode === "workflow" ? (
          <WorkflowConstructor classId={this.props.activeItem} />
        ) : null}
        {this.state.mode === "security" ? (
          <WorkflowSecurity mode="class" objectId={this.props.activeItem} />
        ) : null}
        {this.state.add ? (
          <Modal show={true} onHide={() => this.setState({ add: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Создать класс</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <WorkflowAdd
                activeItem={this.props.activeItem}
                onFinish={(result) => {
                  this.setState({ add: false });
                  this.props.onFinish(result);
                }}
                onCancell={() => this.setState({ add: false })}
              />
            </Modal.Body>
          </Modal>
        ) : null}
      </>
    );
  }
}
